import axios from 'axios'

export default value => {

  if (value === null || !value) {
    return true
  }

  return new Promise((resolve, reject) => {
    
    const payload = {
      value: value
    }
    
    axios.post(`${process.env.VUE_APP_API_BASE_URL}/requesttype/validate`,
      payload, {errorHandle: false})
        .then((response) => {
            console.log(response)
          resolve(!response.data.exists)
        })
        .catch((error) => {
          reject(false)
        })
    })     
  }